import {
  SET_WEBSITE_MODE,
  SET_CURRENT_FILE_KEY,
  SET_DATA_STATUS,
  SET_CURRENT_TAB_INDEX,
  SET_CURRENT_TAB_DATA,
  ADD_NEW_TAB_DATA,
  DELETE_TAB_DATA,
  SET_TOOL_SETTINGS_ACTIVE_INDEX,
  SET_IS_TOOL_SPINNING,
  // UPDATE_CURRENT_TAB_DATA,
  SET_FULLSCREEN_ACTIVE,
  SET_ALL_RESULTS_HAS_UPDATE,
  SET_TITLE_POPUP_INDEX,
  SET_FREEZE_EDITING,
  SET_IS_READING_FILE,
  SET_TOOL_SETTINGS_MORPHING,
  SET_TOOL_SETTINGS_ORIGIN,
} from './constants'
import { createReducer } from '../reducerUtil'

const initialState = {
  websiteMode: 'Normal', //Normal, ShareViewOnly, ShareCanEdit,CollectViewOnly
  freezeEditing: false,
  currentFileKey: '',
  dataStatus: 'Unchanged', //Unchanged | Modified | Saving
  modifiedData: [], // empty when dataStatus not Modified
  currentTabIndex: 0,
  tabsData: [{ tabNumber: 1 }],
  totalTabs: 1,
  toolSettingsActiveIndex: 1, //1 equal close section, 0 equal to open section
  isToolSpinning: false, //whether tool is spinning, currently rtg using only
  fullScreenActive: false, // handleFullScreen.active
  hasAllResultsUpdate: false, // Show yellow badge after a new spin ans when All Results section is hidden
  titlePopupIndex: 0, // Tracks current result title index, loops back to 0 after reaching the last index
  isReadingFile: false,
  toolSettingsMorphing: false,
  toolSettingsOrigin: null,
}

export const setWebsiteMode = (state, payload) => {
  return {
    ...state,
    websiteMode: payload.mode,
  }
}

export const setCurrentFileKey = (state, payload) => {
  return {
    ...state,
    currentFileKey: payload.key,
  }
}

export const setDataStatus = (state, payload) => {
  let usePayloadStatus =
    !!state.currentFileKey && state.websiteMode === 'Normal'
  // if (payload.fromSettings) {
  //   if (!state.tabsData[state.currentTabIndex].hasOwnProperty('settings'))
  //     usePayloadStatus = false
  // }
  const shouldModify = usePayloadStatus && payload.status === 'Modified'

  return {
    ...state,
    dataStatus: usePayloadStatus ? payload.status : state.dataStatus,
    modifiedData: shouldModify
      ? payload.modifiedField !== ''
        ? state.modifiedData.includes(payload.modifiedField)
          ? state.modifiedData
          : [...state.modifiedData, payload.modifiedField]
        : state.modifiedData
      : [],
  }
}

export const setCurrentTabIndex = (state, payload) => {
  return {
    ...state,
    currentTabIndex: payload.index,
  }
}

export const setCurrentTabData = (state, payload) => {
  const newArray = state.tabsData.slice(0)
  newArray[state.currentTabIndex] = {
    tabNumber: newArray[state.currentTabIndex].tabNumber,
    ...payload.data,
  }
  return {
    ...state,
    tabsData: newArray,
  }
}

export const addNewTabData = (state, payload) => {
  return {
    ...state,
    tabsData: [...state.tabsData, { tabNumber: state.totalTabs + 1 }],
    totalTabs: state.totalTabs + 1,
  }
}

export const deleteTabData = (state, payload) => {
  const newArray = state.tabsData.slice(0)
  newArray.splice(payload.index, 1)

  return {
    ...state,
    tabsData: newArray,
    currentTabIndex: payload.newCurrentIndex,
  }
}

export const setToolSettingsActiveIndex = (state, payload) => {
  return {
    ...state,
    toolSettingsActiveIndex: payload.value,
  }
}

export const setIsToolSpinning = (state, payload) => {
  return {
    ...state,
    isToolSpinning: payload.status,
  }
}

export const setFullScreenActive = (state, payload) => {
  return {
    ...state,
    fullScreenActive: payload.status,
  }
}

export const setAllResultsHasUpdate = (state, payload) => {
  return {
    ...state,
    hasAllResultsUpdate: payload.status,
  }
}

export const setTitlePopupIndex = (state, payload) => {
  return {
    ...state,
    titlePopupIndex: payload.index,
  }
}

export const setFreezeEditing = (state, payload) => {
  return {
    ...state,
    freezeEditing: payload.status,
  }
}

export const setIsReadingFile = (state, payload) => {
  return {
    ...state,
    isReadingFile: payload.status,
  }
}

export const setToolSettingsMorphing = (state, payload) => {
  return {
    ...state,
    toolSettingsMorphing: payload.status,
  }
}

export const setToolSettingsOrigin = (state, payload) => {
  return {
    ...state,
    toolSettingsOrigin: payload.value,
  }
}

export default createReducer(initialState, {
  [SET_WEBSITE_MODE]: setWebsiteMode,
  [SET_CURRENT_FILE_KEY]: setCurrentFileKey,
  [SET_DATA_STATUS]: setDataStatus,
  [SET_CURRENT_TAB_INDEX]: setCurrentTabIndex,
  [SET_CURRENT_TAB_DATA]: setCurrentTabData,
  [ADD_NEW_TAB_DATA]: addNewTabData,
  [DELETE_TAB_DATA]: deleteTabData,
  [SET_TOOL_SETTINGS_ACTIVE_INDEX]: setToolSettingsActiveIndex,
  [SET_IS_TOOL_SPINNING]: setIsToolSpinning,
  [SET_FULLSCREEN_ACTIVE]: setFullScreenActive,
  [SET_ALL_RESULTS_HAS_UPDATE]: setAllResultsHasUpdate,
  [SET_TITLE_POPUP_INDEX]: setTitlePopupIndex,
  [SET_FREEZE_EDITING]: setFreezeEditing,
  [SET_IS_READING_FILE]: setIsReadingFile,
  [SET_TOOL_SETTINGS_MORPHING]: setToolSettingsMorphing,
  [SET_TOOL_SETTINGS_ORIGIN]: setToolSettingsOrigin,
})
